import React, { FC } from 'react';

import { Container } from './PageWrapper.styled';

interface PageWrapperProps {
  children: React.ReactNode;
  isSmall?:boolean;
  alignLeft?:boolean;
  /** Nadpisanie max-width kontenera (np. węższy widok /analytics). */
  maxWidth?: string;
  /** Mniejszy margines u góry — gdy nad stroną już jest pasek (np. taby outletów). */
  tightTop?: boolean;
}

export const PageWrapper: FC<PageWrapperProps> = ({
  children, isSmall, alignLeft, maxWidth, tightTop,
}) => (
  <Container
    $isSmall={isSmall}
    $alignLeft={alignLeft}
    $maxWidth={maxWidth}
    $tightTop={tightTop}
  >
    {children}
  </Container>
);
